import { BookingListFilter } from 'lib/graphql/generated';

export const FILTER_OPTIONS: Array<{
  label: string;
  value: string;
  queryFilter: BookingListFilter;
}> = [
  {
    label: 'Upcoming',
    value: 'upcoming',
    queryFilter: 'UPCOMING',
  },
  {
    label: 'Past',
    value: 'past',
    queryFilter: 'COMPLETED',
  },
  {
    label: 'Cancelled',
    value: 'cancelled',
    queryFilter: 'CANCELLED',
  },
];

export const OPTIONS = FILTER_OPTIONS.map(({ label, value }) => ({ label, value }));
export const VALID_FILTERS = FILTER_OPTIONS.map(({ value }) => value);
export const DEFAULT_FILTER = FILTER_OPTIONS[0].value;
